/* BY BIG BOY. Uses existing images; does not change products, prices, or cart state. */
(() => {
  'use strict';
  if (customElements.get('bbb-angle-gallery')) return;
  class BbbAngleGallery extends HTMLElement {
    connectedCallback() {
      if (this.observer) return;
      this.card = this.closest('bbb-print-preview');
      if (!this.card) return;
      try {
        this.data = JSON.parse(this.querySelector('[data-angle-images]').textContent);
        this.data.labels = JSON.parse(document.querySelector('[data-bbb-gallery-labels]').textContent);
      } catch (_) { return; }
      this.controls = this.querySelector('[data-angle-controls]');
      this.status = this.querySelector('[data-angle-status]');
      if (!this.controls || !this.status) return;
      this.controls.setAttribute('aria-label', `${this.data.title} — ${this.data.labels.views}`);
      this.originals = {};
      this.card.querySelectorAll('[data-print-panel]').forEach(panel => {
        const image = panel.querySelector('img');
        if (!image) return;
        if (!image.dataset.bbbOriginalImage) {
          image.dataset.bbbOriginalImage = JSON.stringify({
            src:image.getAttribute('src') || '', srcset:image.getAttribute('srcset') || '',
            sizes:image.getAttribute('sizes') || '', alt:image.alt || '',
            width:image.getAttribute('width') || '', height:image.getAttribute('height') || ''
          });
        }
        try { this.originals[panel.dataset.printPanel] = {image, data:JSON.parse(image.dataset.bbbOriginalImage)}; }
        catch (_) { /* Leave an unusable panel alone. */ }
      });
      this.onClick = event => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('button[data-angle-index]');
        if (button && this.controls.contains(button)) this.select(Number(button.dataset.angleIndex));
      };
      this.onKey = event => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('button[data-angle-index]');
        if (!button || !this.controls.contains(button)) return;
        const buttons = [...this.controls.querySelectorAll('button')];
        let index = buttons.indexOf(button);
        if (event.key === 'ArrowRight') index = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') index = (index + buttons.length - 1) % buttons.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = buttons.length - 1;
        else return;
        event.preventDefault(); buttons[index].focus(); this.select(index);
      };
      this.controls.addEventListener('click',this.onClick);
      this.controls.addEventListener('keydown',this.onKey);
      this.observer = new MutationObserver(() => this.schedule());
      const swatches = this.card.querySelector('.bbwc-choices');
      if (swatches) this.observer.observe(swatches,{subtree:true,attributes:true,attributeFilter:['aria-pressed']});
      this.color = null;
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.observer = null;
      this.controls?.removeEventListener('click',this.onClick);
      this.controls?.removeEventListener('keydown',this.onKey);
      this.removeFailureListener();
    }
    schedule() {
      if (this.queued) return;
      this.queued = true;
      queueMicrotask(() => {this.queued=false;if(this.isConnected)this.sync();});
    }
    validSource(value) {
      if (typeof value !== 'string' || !value) return '';
      try { const u = new URL(value,location.href);return u.protocol==='https:' ? u.href : ''; }
      catch (_) { return ''; }
    }
    thumbnail(src) {
      try { const u=new URL(src,location.href);u.searchParams.set('width','160');return u.href; }
      catch (_) { return src; }
    }
    restore(color) {
      const original=this.originals[color];if(!original)return;
      for(const [key,value] of Object.entries(original.data)) {
        if(value)original.image.setAttribute(key,value);else original.image.removeAttribute(key);
      }
    }
    sync() {
      const selected=this.card.querySelector('.bbwc-choices button[aria-pressed="true"]');
      const color=selected?.dataset.print || 'blue';
      if(this.color===color && this.controls.children.length)return;
      this.removeFailureListener();
      if(this.color)this.restore(this.color);
      this.color=color;
      const original=this.originals[color];
      if(!original){this.hidden=true;return;}
      this.restore(color);
      const labels=this.data.labels;
      this.views=[{key:'front',label:labels.front,...original.data,thumb:this.thumbnail(original.data.src)}];
      const extra=this.data.colors[color] || {};
      for(const key of ['side','back','detail']) {
        const entry=extra[key];
        if(entry && this.validSource(entry.src))this.views.push({key,label:labels[key],...entry});
      }
      this.controls.replaceChildren();
      for(const [index,view] of this.views.entries()) {
        const button=document.createElement('button');button.type='button';button.dataset.angleIndex=String(index);
        button.setAttribute('aria-pressed',String(index===0));button.setAttribute('aria-label',`${this.data.title} — ${view.label}`);
        const thumb=document.createElement('img');thumb.src=this.validSource(view.thumb || view.src);thumb.alt='';thumb.width=72;thumb.height=72;thumb.loading='lazy';
        const label=document.createElement('span');label.textContent=view.label;button.append(thumb,label);this.controls.append(button);
      }
      this.active=0;this.status.textContent='';this.hidden=this.views.length<2;
    }
    removeFailureListener() {
      if(this.failImage && this.onFailure)this.failImage.removeEventListener('error',this.onFailure);
      this.failImage=null;this.onFailure=null;
    }
    select(index) {
      const view=this.views[index];const original=this.originals[this.color];
      if(!view || !original)return;
      this.removeFailureListener();
      if(index===0)this.restore(this.color);
      else {
        const image=original.image;
        this.onFailure=()=>{
          this.removeFailureListener();this.restore(this.color);this.active=0;
          this.controls.querySelectorAll('button').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===0)));
          this.status.textContent=this.data.labels.unavailable;
        };
        this.failImage=image;image.addEventListener('error',this.onFailure,{once:true});
        image.removeAttribute('srcset');image.removeAttribute('sizes');
        if(view.width)image.setAttribute('width',String(view.width));
        if(view.height)image.setAttribute('height',String(view.height));
        image.alt=view.alt || `${this.data.title} — ${view.label}`;image.src=this.validSource(view.src);
      }
      this.active=index;
      this.controls.querySelectorAll('button').forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
      this.status.textContent=view.label;
    }
  }
  customElements.define('bbb-angle-gallery',BbbAngleGallery);
})();
